import Table from 'src/javascripts/components/Table';
import Spinner from 'src/javascripts/components/utilities/Spinner';
import GetCols from 'src/javascripts/components/tables/helpers/GetCols';

export default class PortfolioControversiesTableFund extends Table {

  render(tableId) {

    // Additional detail info
    function formatAddlInfo (row) {
      let details = $(row).attr('data-details');
      let year = $(row).attr('data-year');
      let container = '<div class=\'extra-info-container\'>';
      if (typeof details !== 'undefined') {
        container += '<div class=\'p-3\'>' + details + '</div>';
      }
      container += '<div class=\'px-3 pb-3\'>Year: ' + year + '</div>';
      container += '</div>';
      return container;
    }

    // Set cols
    const cols = GetCols(this.el);

    // Build url, use to get filtered data with server-side processing
    let dataUrl = this.el.attr('data-api-url');

    // Render table
    const table = $('#' + tableId).DataTable({
      ajax: dataUrl,
      pageLength: 10,
      scrollx: true,
      dom: 'tp',
      columns: cols,      
      ordering: true,
      order: [[2, 'asc']],
      language: { 
        emptyTable: "No controversies information available for this fund. Please contact us with any questions.",
      },
      createdRow(row, data, dataIndex) {

        // Add data attrs to row
        $(row).attr('data-details', data.details);
        $(row).attr('data-year', data.year);

      },

      drawCallback: function( settings ) {

        // Hide paging if total display is equal to or less than page length
        if ($('#' + tableId).attr('data-tot-records') < 11) {
          $('#' + tableId + '_paginate').addClass('d-none');
        }

        $('#' + tableId + ' tbody').off('click').on('click', 'tr:not(.expanded-row) td', function () {

          // Set this tr
          let tr = $(this).closest('tr');

          // Remove currently shown row, if any 
          if (tr.hasClass('expanded')) {
            tr.removeClass('expanded');
            tr.closest('table').find('.extra-info-container').empty();
            tr.find('svg.fa-chevron-down').removeClass('fa-chevron-down').addClass('fa-chevron-right');

          } else {
            $('tr.expanded').find('svg.fa-chevron-down').removeClass('fa-chevron-down').addClass('fa-chevron-right');
            $('tr.expanded').removeClass('expanded');
            tr.closest('table').find('.extra-info-container').empty();
            tr.addClass('expanded');

            // Append to tr
            tr.find('.extra-info-container').replaceWith( formatAddlInfo(tr) );
            tr.find('svg.fa-chevron-right').removeClass('fa-chevron-right').addClass('fa-chevron-down');
          }

        });

        // Re-init tooltips for lock icons
        $('[data-toggle=tooltip]').tooltip();

      },

    });

    return 'rendered';

  }
};